import React from 'react';

import { Chart, Series, Tooltip } from 'devextreme-react/chart';
import { SubAccount, ClientsAPI } from "src/api"
// import fullData from '../../data/top_city_bar.json';

const convertData = (data: { [key: string]: number }): { city: string; count: number }[] => {
  return Object.entries(data).map(([city, count]) => ({ city, count }))
}

type CityBarProps = {
  client?: SubAccount
}

class CityBar extends React.Component<CityBarProps> {
  state = {
    data: undefined,
    narrative: undefined

  }

  fetchData = (client: SubAccount) => {
    const params = {
      narrative_assembly_id: "444df7a8-f157-11ea-86cf-0e95a518f8f7",
      report_content_id: "6e06762c-8612-4034-8f0b-bf27bca71702",
      sub_account_id: client.id,
      period_index: "1449",
      period_type:"monthly"
    }
    
    ClientsAPI.getReportData(client, 'top_city_bar.json').then(result => {
      // console.log('done')
      this.setState({ data: result.data });
    }).catch(error => {
      // console.log('error', error)
    })
    
    ClientsAPI.getNarrative(client, params).then(result => {
      // console.log('done', result)
      this.setState({ narrative: result[0]});
    }).catch(error => {
      console.log('error', error)
    })
  }

  parseData = (data: any) =>{
    return Object.entries(data).map(([city, value]) => ({city, value}))
  }

  render() {
    
    const { data, narrative } = this.state;
    const { client } = this.props;
    // const { narrative } = this.state
    if (!data && client) {
      this.fetchData(client);
    }

    if (!data) return null;

    // console.log('has data', narrative)

    return (
      <>
      <Chart id="chart"
        dataSource={this.parseData(data)}
        rotated={true}
        title="Top Cities for this Period">
        {/* <Tooltip
          enabled={true}
        /> */}
        <Series
          valueField="value"
          argumentField="city"
          name="Top Cities"
          type="bar"
          color="#ffaa66" />
      </Chart>
      {JSON.stringify(narrative, null, 2)}
      </>
    );
  }
}

export default CityBar;



// WEBPACK FOOTER //
// ./src/components/ReportComponents/CityBar.tsx